import { useParams } from 'react-router-dom';

export const useSelectedFilter = () => {
    const { status, section } = useParams<{ status?: string; section?: string }>();

    return status || section || null;
};
